document.addEventListener("DOMContentLoaded", function () {

    // Sélectionne toutes les classes du type group-color-xxxxxx
    const items = document.querySelectorAll('li[class*="group-color-"]');

    items.forEach(li => {

        // Trouver la classe group-color-xxxxxx
        const colorClass = [...li.classList].find(c => c.startsWith("group-color-"));
        if (!colorClass) return;

        // Extraire la valeur (046bd2)
        const hex = colorClass.replace("group-color-", "");

        // Ajouter la variable CSS à <li>
        li.style.setProperty("--group-color", "#" + hex);
    });
});
